import { Dispatch, SetStateAction, useState } from 'react';
import { Divider, IconButton, Menu, MenuItem } from '@mui/material';
import MoreVert from '@mui/icons-material/MoreVert';
import { EditWorkpackDialog } from './Dialogs/EditWorkpackDialog';
import { ConfirmationDialog } from '@/components/shared/ConfirmationDialog';
import {
  GetPointOfInterestGroupedByWorkpackDocument,
  useDeleteWorkpackMutation,
} from '@/__generated__/graphql';
import { useSnackBarMessage } from '@/utils/useSnackBarMessage';

type Props = { workpackId: string; workpackName: string };

export const MenuOptions = ({ workpackId, workpackName }: Props) => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | undefined>(undefined);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState<boolean>(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState<boolean>(false);

  const { showSnackBar } = useSnackBarMessage({ variant: 'filled' });

  const [deleteWorkpack, { loading }] = useDeleteWorkpackMutation({
    refetchQueries: [GetPointOfInterestGroupedByWorkpackDocument],
    onCompleted: () => {
      showSnackBar('Workpack has been deleted successfully', 'success');
    },
    onError: (error) => {
      showSnackBar(`${error.message}`, 'error');
    },
  });

  const handleDeleteWorkpack = () => deleteWorkpack({ variables: { input: { workpackId } } });

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };
  const closeMenu = () => setAnchorElement(undefined);

  const handleMenuItemClick = (callback: Dispatch<SetStateAction<boolean>>) => {
    closeMenu();
    callback(true);
  };

  return (
    <>
      <IconButton onClick={(event) => handleMenuClick(event)}>
        <MoreVert />
      </IconButton>
      <Menu anchorEl={anchorElement} open={Boolean(anchorElement)} onClose={closeMenu}>
        <MenuItem onClick={() => handleMenuItemClick(setIsEditDialogOpen)}>Edit workpack</MenuItem>
        <Divider sx={{ margin: '0px !important' }} />
        <MenuItem onClick={() => handleMenuItemClick(setIsDeleteDialogOpen)}>
          Delete workpack
        </MenuItem>
      </Menu>
      {isEditDialogOpen && (
        <EditWorkpackDialog
          isOpen={isEditDialogOpen}
          title="Update Workpack"
          selectedWorkpackId={workpackId}
          selectedWorkpackName={workpackName}
          handleClose={() => setIsEditDialogOpen(false)}
        />
      )}
      {isDeleteDialogOpen && (
        <ConfirmationDialog
          loading={{ state: loading, text: 'Deleting...' }}
          cancelButtonText="Cancel"
          confirmButtonText="Delete Workpack"
          description="Are you sure you want to delete this workpack? All the points of interest inside this workpack will move into “Unassigned” category."
          title="Delete Workpack"
          handleClose={() => setIsDeleteDialogOpen(false)}
          isOpen={isDeleteDialogOpen}
          onConfirm={handleDeleteWorkpack}
          onCancel={() => setIsDeleteDialogOpen(false)}
        />
      )}
    </>
  );
};
